<ng-container
  *flexyooLet="
    tenantName
      ? ('auth.impersonated-as'
        | translate
          : {
              impersonationName: impersonation.firstName + ' ' + impersonation.lastName,
              userName: userName,
              tenantName: tenantName,
            })
      : ('auth.impersonated-as-2'
        | translate
          : {
              impersonationName: impersonation.firstName + ' ' + impersonation.lastName,
              userName: userName,
            }) as content
  "
>
  <h2
    class="header-impersonalized"
    matTooltipClass="header-impersonalized__tooltip"
    [class.header-impersonalized_banner]="isBannerView"
    [matTooltip]="isBannerView ? null : content"
  >
    <span class="header-impersonalized__tenant-name">
      {{ content }}
    </span>
    <a class="impersonalized-link" (click)="close.emit()">
      {{ 'auth.back-to-you-account' | translate }}
    </a>
  </h2>
</ng-container>
